import { render, staticRenderFns } from "./webNav.vue?vue&type=template&id=aaa113a4&scoped=true"
import script from "./webNav.vue?vue&type=script&lang=js"
export * from "./webNav.vue?vue&type=script&lang=js"
import style0 from "./webNav.vue?vue&type=style&index=0&id=aaa113a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa113a4",
  null
  
)

export default component.exports